import { Editor } from "primereact/editor";
import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import { AiOutlineFile } from "react-icons/ai";

import { CardDescription } from "../../../styled"

export function MenuForm(props: any) {
    const { t: translation } = useTranslation();
    const { updateData = false, handleSetValue, itemData, productType } = props

    const [menu, setMenu] = useState<any>();

    useEffect(() => {
        if (itemData?.description) {
            setMenu(itemData.description);
        }
    }, [])


    return (
        <>
            <CardDescription>
                {
                    itemData ? (
                        <div className="title mb-2"><AiOutlineFile fontSize={20} style={{ marginTop: '-5px' }}></AiOutlineFile> {itemData.type_product === 'Discipline' ? translation('material.menuDiscipline') : translation('material.menu')}</div>
                    ) : (
                        <div className="title mb-2"><AiOutlineFile fontSize={20} style={{ marginTop: '-5px' }}></AiOutlineFile> {productType === 'Discipline' ? translation('material.menuDiscipline') : translation('material.menu')}</div>
                    )
                }

                {
                    updateData ? (
                        <Editor style={{ height: '150px' }} id='menu' value={menu} onTextChange={(e) => { setMenu(e.htmlValue); handleSetValue('description', e.htmlValue) }} />
                    ) : (
                        <>
                            <div dangerouslySetInnerHTML={{ __html: itemData?.description }}></div>
                        </>)
                }
            </CardDescription>
        </>
    )
}